// src/Services/gameStatsService.js
import { doc, updateDoc, increment, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import authService from "./authService";

class GameStatsService {
  
  getCurrentMonthKey() {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  }
  
  getCurrentWeekKey() {
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 1);
    const pastDaysOfYear = (now.getTime() - startOfYear.getTime()) / 86400000;
    const weekNumber = Math.ceil((pastDaysOfYear + startOfYear.getDay() + 1) / 7);
    return `${now.getFullYear()}-W${weekNumber}`;
  }
  
  async updateUserStats(gameResult) {
    try {
      const userId = await authService.getCurrentUserId();
      const userRef = doc(db, "users", userId);
      
      const userDoc = await getDoc(userRef);
      if (!userDoc.exists()) {
        console.error("User document not found");
        return;
      }
      
      const userData = userDoc.data();
      const currentStats = userData.stats || {
        totalGamesPlayed: 0,
        totalWins: 0,
        currentWinStreak: 0,
        longestWinStreak: 0,
        lastLoss: false
      };
      
      let newCurrentStreak = currentStats.currentWinStreak;
      let newLongestStreak = currentStats.longestWinStreak;
      
      if (gameResult.isWinner) {
        newCurrentStreak = currentStats.currentWinStreak + 1;
        newLongestStreak = Math.max(newLongestStreak, newCurrentStreak);
      } else {
        newCurrentStreak = 0;
      }
      
      const monthKey = this.getCurrentMonthKey();
      const weekKey = this.getCurrentWeekKey();
      const today = new Date().toISOString().split('T')[0];
      
      await updateDoc(userRef, {
        'stats.totalGamesPlayed': increment(1),
        'stats.totalWins': gameResult.isWinner ? increment(1) : increment(0),
        'stats.currentWinStreak': newCurrentStreak,
        'stats.longestWinStreak': newLongestStreak,
        'stats.lastGameDate': today,
        'stats.lastWinDate': gameResult.isWinner ? today : currentStats.lastWinDate,
        'stats.lastLoss': !gameResult.isWinner,
        
        [`monthlyStats.${monthKey}.gamesPlayed`]: increment(1),
        [`monthlyStats.${monthKey}.wins`]: gameResult.isWinner ? increment(1) : increment(0),
        [`monthlyStats.${monthKey}.winStreak`]: newCurrentStreak,
        
        [`weeklyStats.${weekKey}.gamesPlayed`]: increment(1),
        [`weeklyStats.${weekKey}.wins`]: gameResult.isWinner ? increment(1) : increment(0),
        [`weeklyStats.${weekKey}.winStreak`]: newCurrentStreak,
      });
      
      console.log(`📊 Stats updated:`, {
        won: gameResult.isWinner,
        streak: newCurrentStreak,
        newRecord: newCurrentStreak > currentStats.longestWinStreak
      });
      
    } catch (error) {
      console.error("❌ Error updating stats:", error);
    }
  }
  
  async getUserStats(userId) {
    try {
      const uid = userId || await authService.getExistingUserId();
      if (!uid) return { totalGamesPlayed: 0, totalWins: 0, currentWinStreak: 0, longestWinStreak: 0 };
      const userRef = doc(db, "users", uid);
      const userDoc = await getDoc(userRef);
      
      if (userDoc.exists()) {
        return userDoc.data().stats || {
          totalGamesPlayed: 0,
          totalWins: 0,
          currentWinStreak: 0,
          longestWinStreak: 0
        };
      }
      
      return {
        totalGamesPlayed: 0,
        totalWins: 0,
        currentWinStreak: 0,
        longestWinStreak: 0
      };
    } catch (error) {
      console.error("❌ Error getting user stats:", error);
      return {
        totalGamesPlayed: 0,
        totalWins: 0,
        currentWinStreak: 0,
        longestWinStreak: 0
      };
    }
  }
}

export const gameStatsService = new GameStatsService();
export default gameStatsService;